import { useMemo } from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import CardMedia from "../Media/CardMedia";
import { useMediaDimensions } from "../../hooks/useMediaDimensions";
import { getCarouselCardPreviewLayout } from "../../utils/dimensions";

const mediaFitSx = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

const ContentFieldAdaptivePreview = ({ url, sxPreview = {} }) => {
  const { dimensions, loading } = useMediaDimensions(url);

  const previewLayout = useMemo(
    () => getCarouselCardPreviewLayout(dimensions),
    [dimensions]
  );

  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        sx={{
          width: "100%",
          aspectRatio: 1,
          marginBottom: "8px",
          borderRadius: 3,
          ...sxPreview,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        width: previewLayout.width,
        maxWidth: "100%",
        maxHeight: previewLayout.maxHeight,
        aspectRatio: previewLayout.aspectRatio,
        marginBottom: "8px",
        borderRadius: 3,
        overflow: "hidden",
        bgcolor: "action.hover",
        flexShrink: 0,
        ...sxPreview,
      }}
    >
      <CardMedia
        url={url}
        propsType={{
          controls: false,
          autoplay: false,
          loop: false,
        }}
        sx={{
          width: "100%",
          height: "100%",
        }}
        sxImage={mediaFitSx}
        sxVideo={mediaFitSx}
      />
    </Box>
  );
};

export default ContentFieldAdaptivePreview;
